<section class="mh-about" id="rdm-about">
  <div class="container">
    <div class="row section-separator">
      <div class="col-sm-12 col-md-6">
        <div class="mh-about-img shadow-2 wow fadeInUp"
          data-wow-duration="0.8s" data-wow-delay="0.4s">
          <img src="assets/images/ab-img-user.png" alt=""
            class="img-fluid">
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="mh-about-inner">
          <h2 class="wow fadeInUp" data-wow-duration="0.8s"
          data-wow-delay="0.1s">Sobre mim</h2>
          <p class="wow fadeInUp" data-wow-duration="0.8s"
            data-wow-delay="0.2s">Olá, eu sou
            engenheiro de software e trabalho com desenvolvimento de sistemas de inteligência artificial.
            Possuo mais de 12 anos de experência no desenvolvimento
            de
          aplicações usando diversas tecnologias. Sendo elas:</p>
          <div class="mh-about-tag wow fadeInUp"
            data-wow-duration="0.8s" data-wow-delay="0.3s">
            <ul>
              <li><span>Node.JS</span></li>
              <li><span>Javascript</span></li>
              <li><span>Typescript</span></li>
              <li><span>Python</span></li>
              <li><span>Watson</span></li>
              <li><span>Watsonx & GenAI</span></li>
              <li><span>Engenharia de Software</span></li>
              <li><span>IA</span></li>
              <li><span>Open CV</span></li>
              <li><span>MongoDB</span></li>
              <li><span>Angular</span></li>
              <li><span>.NET</span></li>
              <li><span>C#</span></li>
              <li><span>AWS</span></li>
              <li><span>SQL Server</span></li>
              <li><span>PostgreSQL</span></li>
            </ul>
          </div>
          @if (downloadCV) {
            <a href="" class="btn btn-fill wow fadeInUp"
              data-wow-duration="0.8s" data-wow-delay="0.4s">Download
              CV <i class="fa fa-download"></i></a>
            }
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="mh-service">
    <div class="container">
      <div class="row section-separator">
        <div class="col-sm-12 text-center section-title wow fadeInUp"
          data-wow-duration="0.8s" data-wow-delay="0.2s">
          <h2>O que eu faço</h2>
        </div>
        <div class="col-sm-4">
          <div class="mh-service-item shadow-1 dark-bg wow fadeInUp"
            data-wow-duration="0.8s" data-wow-delay="0.3s">
            <i class="fa fa-bullseye purple-color"></i>
            <h3>AI Development</h3>
            <p>
              Desenvolvimento de soluções usando modelos de Machine Learning,
              API's de plataformas cognitivas,
              Visão Computacional e processamento de linguagem natural.
            </p>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mh-service-item shadow-1 dark-bg wow fadeInUp"
            data-wow-duration="0.8s" data-wow-delay="0.5s">
            <i class="fa fa-code iron-color"></i>
            <h3>Web Development</h3>
            <p>
              Criação de aplicações web dos mais diversos segmentos,
              sendo eles: sistemas administrativos, sistema de gestão
              hospitalar, sites pessoais e plataformas de curadoria.
            </p>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mh-service-item shadow-1 dark-bg wow fadeInUp"
            data-wow-duration="0.8s" data-wow-delay="0.7s">
            <i class="fa fa-object-ungroup sky-color"></i>
            <h3>Software Engineer</h3>
            <p>
              Responsável por aplicar os mais
              modernos padrões de desenvolvimento de softwares e novas
              tecnologias que proporcionarão qualidade e segurança.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>